// context/workConfig.js
import React, { createContext, useContext } from 'react';

// Projects data
const projectsData = [
    // viva rai2
    {
        id: "1",
        title: "project1_title",
        client: "RAI",
        year: "2023-2024",
        category: "motion graphics",
        description: "project1_description",
        longDescription: "project1_long_description",
        services: [
            "project1_service1",
            "project1_service2",
            "project1_service3",
            "project1_service4",
            "project1_service5"
        ],
        technologies: ["After Effects", "Unreal Engine", "Cinema 4D", "Blender", "Adobe Photoshop"],
        mainImage: "/img/work1.png",
        gallery: [
            { type: "image", url: "/img/works/1/1_1.png", caption: "project1_gallery1_caption" },
            { type: "image", url: "/img/works/1/1_2.png", caption: "project1_gallery2_caption" },
            { type: "image", url: "/img/works/1/1_3.png", caption: "project1_gallery3_caption" }
        ],
        videoUrl: "https://www.montevulture.it/varie/video/work1.mp4",
        colors: ["#B1523Dff", "#240908ff", "#D9BAA1ff"],
        testimonial: {
            quote: "project1_testimonial_quote",
            author: "Mirea Crescenza",
            role: "project1_testimonial_role"
        }
    },
    // d&g
    {
        id: "2",
        title: "project2_title",
        client: "Dolce&Gabbana",
        year: "2021",
        category: "virtual production",
        description: "project2_description",
        longDescription: "project2_long_description",
        services: [
            "project2_service1",
            "project2_service2",
            "project2_service3",
            "project2_service4"
        ],
        technologies: ["Unreal Engine", "LED Wall Systems", "Real-Time Rendering"],
        mainImage: "/img/work2.png",
        gallery: [
            { type: "image", url: "/img/works/2/2_3.png", caption: "project2_gallery1_caption" },
            { type: "image", url: "/img/works/2/2_2.jpg", caption: "project2_gallery2_caption" }
        ],
        videoUrl: "https://www.montevulture.it/varie/video/work2.mp4",
        colors: ["#B21125ff", "#180B09ff", "#f1f1f1f1"]
    },
    // ulisse
    {
        id: "3",
        title: "project3_title",
        client: "RAI",
        year: "2020-2022",
        category: "virtual production",
        description: "project3_description",
        longDescription: "project3_long_description",
        services: [
            "project3_service1",
            "project3_service2",
            "project3_service3",
            "project3_service4",
            "project3_service5"
        ],
        technologies: ["Unreal Engine", "Pixotope", "Stype", "After Effects", "Blender"],
        mainImage: "/img/work3.png",
        gallery: [
            { type: "image", url: "/img/works/3/3_2.png", caption: "project3_gallery1_caption" },
            { type: "image", url: "/img/works/3/3_3.png", caption: "project3_gallery2_caption" },
            { type: "image", url: "/img/works/3/3_1.png", caption: "project3_gallery3_caption" }
        ],
        videoUrl: "https://www.montevulture.it/varie/video/work3.mp4",
        colors: ["#3a506b", "#c5d1eb", "#212121"],
        testimonial: {
            quote: "project3_testimonial_quote",
            author: "Luca Verdi",
            role: "project3_testimonial_role"
        }
    },
    // apulia digital maker
    {
        id: "4",
        title: "project4_title",
        client: "ITS Apulia Digital Maker",
        year: "2020-2023",
        category: "education",
        description: "project4_description",
        longDescription: "project4_long_description",
        services: [
            "project4_service1",
            "project4_service2",
            "project4_service3",
            "project4_service4"
        ],
        technologies: ["Unreal Engine", "Blender", "Camera Tracking Systems", "Virtual Production Pipeline"],
        mainImage: "/img/work4.png",
        gallery: [
            { type: "image", url: "/img/works/4/4_1.png", caption: "project4_gallery1_caption" },
            { type: "image", url: "/img/works/4/4_2.png", caption: "project4_gallery2_caption" }
        ],
        videoUrl: "https://www.montevulture.it/varie/video/work4.mp4",
        testimonial: {
            quote: "project4_testimonial_quote",
            author: "Giuseppe Castellabate",
            role: "project4_testimonial_role"
        }
    },
    // Vstudio e AR la7
    {
        id: "5",
        title: "project5_title",
        client: "Rainews24 / LA7",
        year: "2014-2023",
        category: "augmented reality",
        description: "project5_description",
        longDescription: "project5_long_description",
        services: [
            "project5_service1",
            "project5_service2",
            "project5_service3",
            "project5_service4",
            "project5_service5"
        ],
        technologies: ["Unreal Engine", "Cinema 4D", "Blender", "After Effects", "Avid Maestro", "ClassX", "3D Designer", "Adobe Photoshop"],
        mainImage: "/img/work5.png",
        gallery: [
            { type: "image", url: "/img/works/5/5_1.png", caption: "project5_gallery1_caption" },
            { type: "image", url: "/img/works/5/5_2.png", caption: "project5_gallery2_caption" }
        ],
        videoUrl: "https://www.montevulture.it/varie/video/work5.mp4"
    }
];

// Create the context
const WorksContext = createContext();

// Provider component
export const WorksProvider = ({ children }) => {
    const value = {
        projects: projectsData,
        getProjectById: (id) => projectsData.find(project => project.id === id),
        getNextProject: (id) => {
            const currentIndex = projectsData.findIndex(project => project.id === id);
            const nextIndex = (currentIndex + 1) % projectsData.length;
            return projectsData[nextIndex];
        }
    };

    return (
        <WorksContext.Provider value={value}>
            {children}
        </WorksContext.Provider>
    );
};

// Custom hook to use the works context
export const useWorks = () => {
    const context = useContext(WorksContext);
    if (context === undefined) {
        throw new Error('useWorks must be used within a WorksProvider');
    }
    return context;
};

// Direct export of the data (alternative approach if context is not needed)
export const projects = projectsData;